import { PublicHttpService } from '../../../routes/teacher/public-http.service';
import { Component, OnInit, Injector, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { RespEntityUtil } from '../../../routes/teacher/entity/respEntityUtil';
import { SelectAssemblyParams } from './selectAssemblyParams';
import * as publicMethods from '@shared/utils/publicMethods';

@Component({
    selector: 'app-select-assembly',
    templateUrl: './select-assembly.component.html',
    styles: []
})
export class SelectAssemblyComponent extends PublicHttpService implements OnInit {

    @Output() private valChange = new EventEmitter<string>();
    @Output() private loadEnd = new EventEmitter<string>();
    // 参数信息
    @Input() public params: SelectAssemblyParams;
    // 下拉框加载的数据
    public datas: Array<RespEntityUtil> = [];
    // 单选时选中的数据id
    public selectId = '';
    // 多选时选中的数据id数组
    public selectIds: Array<any> = [];

    loading: boolean;

    constructor(protected injector: Injector, public cdr: ChangeDetectorRef) {
        super(injector);
    }

    clearAll(e: any) {
        if (e === null) {
            this.selectId = '';
            this.selectIds = [];
        }
    }

    /**
     * 查询下拉框数据
     */
    getDatas(data?: any) {
        this.loading = true;
        let par = null;
        if (this.params.params) {
            par = publicMethods.generateFormData(this.params.params);
        }
        if (data) {
            if (this.params.params) {
                Object.keys(data).forEach(key => {
                    par.set(key, data[key]);
                });
            } else {
                par = publicMethods.generateFormData(data);
            }
        }
        super.getSelectData(this.params.url, par)
            .subscribe((arr: Array<RespEntityUtil>) => {
                this.loading = false;
                // 手动进行变更检测视图
                this.cdr.markForCheck();
                if (arr.length > 0 && this.params.isAddNull) {
                    arr.unshift(new RespEntityUtil('', '无'));
                }
                if (arr.length > 0) {
                    this.selectId = arr[0].openid;
                }
                this.datas = arr;
                if (this.params.isLoadEnd) {
                    this.loadEnd.emit('加载完成！');
                }
            });
    }

    // 当下拉框值发生改变的时候
    ngModelChange($event: any) {
        if ($event) {
            this.sendVal();
        }
    }


    sendVal() {
        this.valChange.emit('下拉框值改变了');
    }

    ngOnInit() {
        this.getDatas(this.params.params);
    }

}
